import { gql, useMutation } from "@apollo/client";
import { Button, Col, Form, InputNumber, Row, Space, Typography } from "antd";
import { keys, toNumber } from "lodash";
import React, { useState } from "react";

const updateStocksMutation = gql`
  mutation($input: UpdateStocksInput!) {
    updateStocks(input: $input) {
      results {
        successful
        stock {
          id
          quantity
        }
      }
    }
  }
`;

interface FieldData {
  name: string;
  errors: string[];
}

export const EditStocks: React.FC<{ resource: any }> = (props) => {
  const { stocks } = props.resource;

  const [form] = Form.useForm();
  const [formChanged, setFormChanged] = useState(false);

  const [execMutation, { loading }] = useMutation(updateStocksMutation, {
    errorPolicy: "none",
    onError: ({ graphQLErrors }) => {
      const fieldsErrors: FieldData[] = [];
      const otherErrors: string[] = [];
      graphQLErrors?.forEach((graphQLError) => {
        if (graphQLError.name) {
          fieldsErrors.push({ name: graphQLError.name, errors: (graphQLError as any).messages });
        } else {
          otherErrors.push(graphQLError.message);
        }
      });
      form.setFields(fieldsErrors);
    },
    onCompleted: (data) => {
      setFormChanged(false);
    },
  });

  const onFinish = (values: any) => {
    const input = { stocks: keys(values).map((id: any) => ({ id, quantity: toNumber(values[id]) })) };
    execMutation({ variables: { input } });
  };

  const values: any = {};
  stocks?.forEach((stock: any) => {
    values[stock.id] = stock.quantity;
  });

  return (
    <Form form={form} initialValues={values} onValuesChange={() => setFormChanged(true)} onFinish={onFinish}>
      <Row>
        {stocks?.map((stock: any, i: any) => (
          <Col span={3} key={i}>
            <Typography.Text strong>{stock.size.code}</Typography.Text>
            <Form.Item name={stock.id}>
              <InputNumber min={0} onFocus={(e) => e.target.select()} />
            </Form.Item>
          </Col>
        ))}
        {formChanged && (
          <Space>
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                form.submit();
              }}
            >
              Save
            </Button>
          </Space>
        )}
      </Row>
    </Form>
  );
};
